import { render } from "./OjtAssessment.vue?vue&type=template&id=39686538"
import script from "./OjtAssessment.vue?vue&type=script&lang=js"
export * from "./OjtAssessment.vue?vue&type=script&lang=js"

import "./OjtAssessment.vue?vue&type=style&index=0&id=39686538&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__